<template>
  <div id="doc-invoices">
    <p>Bald werden Sie hier Rechnungen herunterladen können!</p>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'doc-invoices',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters('organization', { organization: 'currentOrganization' }),
  },
  created () {
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus">
#doc-invoices p
  padding: 32px
</style>
